<div class="search">
	@if(!startSearch) {
		<button (click)="toggleSearch()" class="btn btn-grey-outline">
			Search <i class="icon-mag"></i>
		</button>
	}

	@if(startSearch) {
		<div class="search-filters-section" layout="row" layout-align="start start">
			<div style="display: inline-block; vertical-align: top; margin-top: 18px;">
				<small class="color-gray-md" style="display: inline-block;" (click)="toggleSearch()">Hide</small>
			</div>

			<form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="form-inline" novalidate layout="row" layout-align="end center" style="display: inline-block; width: 100%;">
				<!-- Search Field -->
				<div class="waiting-room-filter">
					<div class="relative">
						<input class="form-control" id="visit-search-field" formControlName="search" placeholder="Name, Visit#, Phone#">
						@if (searchForm.get('search')?.value) {
							<i class="icon-x-circle input-icon--right no-label" (click)="searchForm.get('search')?.reset()"></i>
						}
					</div>
				</div>

				<!--			&lt;!&ndash; Category Filter &ndash;&gt;-->
				<div class="waiting-room-filter">
          <lib-multi-select
            [label] = '"Categories"'
            [multiSelectItems]="asCategory(visitOrdersStore.flattenVisitCategoryOrderSelect()) || []"
            [inputPlaceholder]='"Categories"'
            (selectionEmitter)="categorySelectChange($event)"
            [reset]="formReset"
          />
				</div>

				<!-- Status Filter -->
        <div class="waiting-room-filter">
          <lib-multi-select
            [label] = '"Visit Status"'
            [multiSelectItems]="asStatus(visitOrdersStore.adminStatusesSelect()) || []"
            [inputPlaceholder]='"Visit Status"'
            (selectionEmitter)="adminStatusSelectChange($event)"
            [reset]="formReset"
          />
        </div>

				<div class="waiting-room-filter">
					<div>
						<date-range-picker [(formReset)]="formReset" (dateRangeSelected)="updateDateRange($event)"></date-range-picker>
					</div>
				</div>

				<!-- Visit Type Filter -->
				<div class="waiting-room-filter">
					<div class="select-box">
						<select class="form-control" formControlName="is_slv">
							@for (type of (allVisitTypes$ | async); track $index) {
							<option [value]="type.type">{{type.description}}</option>
							}
						</select>
					</div>
				</div>

				<!-- Search Button -->
				<div class="waiting-room-filter">
					<button class="btn btn-success" type="submit">Search <i class="icon-mag"></i></button>
				</div>

				<!-- Save Search Checkbox -->
				<div class="waiting-room-filter">
					<input type="checkbox" formControlName="saveFilter" class="checkbox blue-checkbox" id="save-search">
					<label class="label-save-search" for="save-search">Save search</label>
				</div>

				<!-- Include Flagged Checkbox -->
				<div class="waiting-room-filter">
					<input type="checkbox" class="checkbox blue-checkbox" id="include-flagged" formControlName="include_all_blocked">
					<label class="label-save-search" for="include-flagged">Include flagged</label>
				</div>

				<!-- Reset Filters -->
				<div class="waiting-room-filter">
					<div class="reset-filter-wrapper" (click)="resetFilters()">
						<i class="icon-x-circle-line" style="font-size: 18px;"></i>
						<div class="reset-filter-text">Reset</div>
					</div>
				</div>
			</form>
		</div>
	}
</div>
